import React from "react";

export const PAGE_SIZE = 5;

// Returns the visible slice for a (possibly stale) page index, the clamped
// page, and the total page count — so callers never render an out-of-range page.
export function paginate(items, page, pageSize = PAGE_SIZE) {
  const pageCount = Math.max(1, Math.ceil(items.length / pageSize));
  const safePage = Math.min(Math.max(page, 0), pageCount - 1);
  const start = safePage * pageSize;
  return { slice: items.slice(start, start + pageSize), safePage, pageCount };
}

export default function Pagination({ page, pageCount, onPrev, onNext }) {
  if (pageCount <= 1) return null;
  return (
    <div className="flex items-center justify-between pt-3 mt-auto border-t border-border text-xs text-muted-foreground">
      <span>
        Page {page + 1} of {pageCount}
      </span>
      <div className="flex gap-1">
        <button
          type="button"
          aria-label="previous page"
          onClick={onPrev}
          disabled={page === 0}
          className="px-2 py-1 rounded border border-border hover:bg-gray-50 disabled:opacity-40 disabled:cursor-default"
        >
          Prev
        </button>
        <button
          type="button"
          aria-label="next page"
          onClick={onNext}
          disabled={page >= pageCount - 1}
          className="px-2 py-1 rounded border border-border hover:bg-gray-50 disabled:opacity-40 disabled:cursor-default"
        >
          Next
        </button>
      </div>
    </div>
  );
}
